export default __webpack_public_path__ + "static/media/filterHover.6f026be2.svg";